import { render, staticRenderFns } from "./BjiImportOrderRecordEditDialog.vue?vue&type=template&id=85b4e558&lang=pug"
import script from "./BjiImportOrderRecordEditDialog.vue?vue&type=script&lang=js"
export * from "./BjiImportOrderRecordEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports